import React, {FC} from 'react';
import { useTranslation } from 'react-i18next';
import styles from './confirm-territory-phase-modal.module.scss'
import rejectIcon from "../../../../images/error-120.svg";
import Button from "../../../ui-kit/button/button";
import Modal from "../../../../shared/modal/modal";

interface ConfirmTerritoryPhaseModalProps {
    onClose: () => void;
}

const ConfirmTerritoryPhaseModal: FC<ConfirmTerritoryPhaseModalProps> = ({ onClose }) => {
    const { t } = useTranslation();

    return (
        <Modal closeOnOverlayClick={false} onClose={onClose}>
            <div className={styles.verifiedConfirmTerritoryModal}>
                <h1 className={styles.title}>{t('main-form-create-study.confirmTerritoryModalTitle')}</h1>
                <img className={styles.image} src={rejectIcon} alt='reject'/>
                <span className={styles.text}>{t('main-form-create-study.confirmTerritoryModalText')}</span>
                <p className={styles.description}>{t('main-form-create-study.confirmTerritoryModalDescription')}</p>
                <Button
                    type='primary'
                    onClick={onClose}
                    className={styles.btn}
                >
                    {t('main-form-create-study.confirmTerritoryModalBtn')}
                </Button>
            </div>
        </Modal>
    );
};

export default ConfirmTerritoryPhaseModal;